/** @format */

import React, { useState } from 'react'

import { Modal, Input, Button } from 'antd'
import { CloseOutlined } from '@ant-design/icons'

export default function RejectDigital(props) {
	const [digitalReasonReject, setDigitalReasonReject] = useState('')

	return (
		<>
			<Button
				onClick={() => props.setDigitalModal((pvSt) => ({ ...pvSt, rejected: true }))}
				type='primary'
				icon={<CloseOutlined />}
				danger={true}
				className='ph-order-actions-buttons'>
				<span>Rechazar</span>
			</Button>
			<Modal
				onCancel={() => props.setDigitalModal((pvSt) => ({ ...pvSt, rejected: false }))}
				visible={props.digitalModal.rejected}
				footer={[
					<Button
						type='primary'
						danger={true}
						onClick={() => props.handleAproveOrRejectDigital(digitalReasonReject, 'rejected')}>
						Rechazar
					</Button>,
				]}>
				<Input.TextArea
					placeholder='Motivo de rechazo'
					onChange={(e) => setDigitalReasonReject(e.target.value)}
				/>
			</Modal>
		</>
	)
}
